<template>
  <div class="index-container">
    <Header></Header>
    <div class="schedule-panel">
      <div class="panel-header">
        <div class="header-left">
          <el-button 
            type="text" 
            icon="el-icon-back" 
            @click="goBack"
            class="back-btn">
            返回
          </el-button>
          <h2>案件日程设置</h2>
        </div>
        <div class="case-info">
          <span>案件名称：{{casename}}</span>
          <!-- <div class="view-switch">
            <span class="switch-label">客户可见：</span>
            <el-switch
              v-model="isClientViewEnabled"
              @change="handleClientViewChange"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </div> -->
          <el-button type="primary" size="small" @click="fetchData">刷新数据</el-button>
        </div>
      </div>
      <el-card shadow="hover" class="schedule-card">
        <el-table 
          :data="processedScheduleList" 
          border 
          style="width: 100%"
          :header-cell-style="{
            background: '#f5f7fa',
            color: '#606266',
            fontWeight: 'bold',
            fontSize: '14px'
          }"
          :row-class-name="tableRowClassName">
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="setupname" label="阶段名称" width="120" align="center"> </el-table-column>
          <el-table-column prop="name" label="节点名称" width="120" align="center">
            <template slot-scope="scope">
              {{scope.row.name}}
              <el-switch
                v-model="scope.row.isshowValue"
                @change="handleIsshowChange(scope.row)"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </template>

          </el-table-column>
          <el-table-column label="节点日期" width="250" align="center">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.automsgtime"
                type="date"
                placeholder="选择日期"
                @change="handleDateChange(scope.row)"
                value-format="yyyy-MM-dd"
                size="small"
                class="custom-date-picker">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="通知时间" width="300" align="center">
            <template slot-scope="scope">
              <div class="notify-time">
                <div class="notify-row">
                  <div class="notify-item">
                    <span class="label">律师：</span>
                    <div class="input-wrapper">
                      <el-select 
                        v-model="scope.row.islawyermsg" 
                        @change="handleNotifyTypeChange(scope.row, 'lawyer')"
                        size="small"
                        class="custom-select">
                        <el-option 
                          v-for="item in notifyTypeOptions" 
                          :key="item.value" 
                          :label="item.label" 
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <div class="days-wrapper" v-if="[2, 3].includes(scope.row.islawyermsg)">
                        <el-input
                          v-model.number="scope.row.lsmsgdays"
                          size="small"
                          type="number"
                          @change="handleNotifyDaysChange(scope.row, 'lawyer')"
                          @blur="validateDays(scope.row, 'lawyer')"
                          class="days-input">
                        </el-input>
                        <span class="days-label">天</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="notify-row">
                  <div class="notify-item">
                    <span class="label">客户：</span>
                    <div class="input-wrapper">
                      <el-select 
                        v-model="scope.row.isclientmsg" 
                        @change="handleNotifyTypeChange(scope.row, 'client')"
                        size="small"
                        class="custom-select">
                        <el-option 
                          v-for="item in notifyTypeOptions" 
                          :key="item.value" 
                          :label="item.label" 
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <div class="days-wrapper" v-if="[2, 3].includes(scope.row.isclientmsg)">
                        <el-input
                          v-model.number="scope.row.khmsgdays"
                          size="small"
                          type="number"
                          @change="handleNotifyDaysChange(scope.row, 'client')"
                          @blur="validateDays(scope.row, 'client')"
                          class="days-input">
                        </el-input>
                        <span class="days-label">天</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="节点负责人" width="150" align="center">
            <template slot-scope="scope">
              <div class="notify-object">
                <div class="notify-item">
                  <el-select 
                    v-model="scope.row.nodemanger" 
                    @change="handleLawyerChange(scope.row)"
                    size="small"
                    class="custom-select">
                    <el-option 
                      v-for="lawyer in lawyerList" 
                      :key="lawyer.id" 
                      :label="lawyer.name" 
                      :value="lawyer.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="加入日程" width="100" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.switchValue"
                @change="handleScheduleChange(scope.row)"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>

            </template>
            
          </el-table-column>
          <el-table-column label="短信模板" min-width="180" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.lawyermsgkw1"
                size="small"
                 placeholder="关键字"
                @change="handleLawyerMsgChange(scope.row)"
                class="msg-input">
              </el-input>
              <div class="msg-text" >
                <span class="msg-text-label">{{scope.row.lawyermsgkw1}}案{{scope.row.name}}阶段已快到期，请及时处理。</span>
                <span style="color: #909399; font-size: 12px;">[{{ scope.row.lsmsgtime }}]</span>
              </div>
              <div class="client-msg-inputs" style="margin-top: 18px;">
                <el-input
                  v-model="scope.row.clientmsgkw1"
                  size="small"
                  @change="handleClientMsgChange(scope.row)"
                  class="msg-input"
                  placeholder="关键字1">
                </el-input>
                <el-input
                  v-model="scope.row.clientmsgkw2"
                  size="small"
                  @change="handleClientMsgChange(scope.row)"
                  class="msg-input"
                  placeholder="关键字2">
                </el-input>
              </div>
              <div class="msg-text">
                <span class="msg-text-label">尊敬的客户，您的案件已进入{{scope.row.clientmsgkw1}}阶段，请{{scope.row.clientmsgkw2}}。</span>
                <span style="color: #909399; font-size: 12px;">[{{ scope.row.khmsgtime }}]</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="客户短信模板" min-width="280" align="center">
            <template slot-scope="scope">
              <div class="client-msg-inputs">
                <el-input
                  v-model="scope.row.clientmsgkw1"
                  size="small"
                  @change="handleClientMsgChange(scope.row)"
                  class="msg-input"
                  placeholder="关键字1">
                </el-input>
                <el-input
                  v-model="scope.row.clientmsgkw2"
                  size="small"
                  @change="handleClientMsgChange(scope.row)"
                  class="msg-input"
                  placeholder="关键字2">
                </el-input>
              </div>
              <div class="msg-text">
                <span class="msg-text-label">尊敬的客户，您的案件已进入{{scope.row.clientmsgkw1}}阶段，请{{scope.row.clientmsgkw2}}。</span>
                <span style="color: #909399; font-size: 12px;">[{{ scope.row.khmsgtime }}]</span>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
      </el-card>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import caseApi from '@/api/case'
import { getCaseSchedule,setcaseSchedule, getLawyerList, updateScheduleItem } from '@/api/case'

export default {
  name: "SetSchedule",
  components: {
    Header
  },
  data() {
    return {
      isClientViewEnabled: false,
      isclientview: 0,
      casename: '',
      scheduleList: [],
      lawyerList: [],
      notifyTypeOptions: [
        { value: 0, label: '不通知' },
        { value: 1, label: '当日' },
        { value: 2, label: '提前' },
        { value: 3, label: '延后' }
      ],
      // 模拟数据
      mockLawyerList: [],
      mockScheduleList: [
        {
          id: 1,
          stepName: '立案',
          nodeName: '提交材料',
          nodeDate: '2024-01-15',
          islawyermsg: 2,
          lawyerNotifyDays: 2,
          isclientmsg: 2,
          clientNotifyDays: 3,
          nodemanger: 1,
          clientName: '张三',
          autoschedule: 1,
          lawyermsgkw1: '请准备立案材料',
          clientmsgkw1: '请准备',
          clientmsgkw2: '相关证据材料'
        },
        {
          id: 2,
          stepName: '庭审',
          nodeName: '一审',
          nodeDate: '2024-02-20',
          islawyermsg: 2,
          lawyerNotifyDays: 3,
          isclientmsg: 2,
          clientNotifyDays: 4,
          nodemanger: 2,
          clientName: '张三',
          autoschedule: 1,
          lawyermsgkw1: '请准备庭审材料',
          clientmsgkw1: '请准时',
          clientmsgkw2: '参加庭审'
        },
        {
          id: 3,
          stepName: '调解',
          nodeName: '调解会议',
          nodeDate: '2024-03-10',
          islawyermsg: 1,
          lawyerNotifyDays: 0,
          isclientmsg: 2,
          clientNotifyDays: 2,
          nodemanger: 1,
          clientName: '张三',
          autoschedule: 0,
          lawyermsgkw1: '请准备调解方案',
          clientmsgkw1: '请准时',
          clientmsgkw2: '参加调解会议'
        }
      ]
    }
  },
  computed: {
    // 处理表格数据，添加switchValue用于绑定开关
    processedScheduleList() {
      return this.scheduleList.map(item => ({
        ...item,
        switchValue: item.autoschedule === 1,
        isshowValue: item.isshow === 1
      }))
    }
  },
  watch: {
    // 监听scheduleList变化，更新switchValue
    scheduleList: {
      immediate: true,
      handler(val) {
        val.forEach(item => {
          this.$set(item, 'switchValue', item.autoschedule === 1)
          this.$set(item, 'isshowValue', item.isshow === 1)
        })
      }
    }
  },
  created() {
    this.fetchData()
    this.fetchHandlers()
    this.isClientViewEnabled = this.isclientview === 1
  },
  methods: {
    getStepTagType(stepName) {
      const typeMap = {
        '立案': 'primary',
        '庭审': 'success',
        '调解': 'warning'
      }
      return typeMap[stepName] || 'info'
    },
    tableRowClassName({row}) {
      if (row.autoschedule === 1) {
        return 'schedule-enabled-row'
      }
      return ''
    },
     // 获取律师列表
     async fetchHandlers() {
      const response = await caseApi.getLawyerList();
      console.log(response);
      this.lawyerList = response.data.map(item => ({
        id: item.uid,
        name: item.real_name
      }));
      console.log(this.lawyerList);

    },

    async fetchData() {
      const caseId = this.$route.query.id
      if (!caseId) {
        this.$message.error('案件ID不能为空')
        return
      }

      try {
        const scheduleRes = await getCaseSchedule({caseid: caseId})
        console.log(scheduleRes);
        this.scheduleList = scheduleRes.data.nodes
        this.casename = scheduleRes.data.casename
        if (scheduleRes.data.isclientview !== undefined) {
          this.isclientview = scheduleRes.data.isclientview
          this.isClientViewEnabled = scheduleRes.data.isclientview === 1
        }
      } catch (error) {
        this.$message.error('获取数据失败：' + error.message)
      } 
    },
    async updateSchedule(row) {
      // 模拟更新成功
      this.$message({
        message: '更新成功',
        type: 'success',
        duration: 2000
      })
      console.log('更新的数据：', row)
      const data = {
        automsgtime: row.automsgtime,
        islawyermsg: row.islawyermsg,
        lsmsgdays: row.lsmsgdays,
        isclientmsg: row.isclientmsg,
        khmsgdays: row.khmsgdays,
        nodemanger: row.nodemanger,
        name: row.name,
        autoschedule: row.autoschedule,
        lawyermsgkw1: row.lawyermsgkw1,
        clientmsgkw1: row.clientmsgkw1,
        clientmsgkw2: row.clientmsgkw2,
        isshow: row.isshow
      }
     console.log(data);
      try {
       const res = await caseApi.setCaseSchedule({id: row.id, row:data,caseid: this.$route.query.id})
       console.log(res);
       if (res) {
        this.fetchData()
       }
      } catch (error) {
        this.$message.error('更新失败：' + error.message)
      }

      
      // 保留原有API调用逻辑，注释掉防止报错
      /* try {
        await updateScheduleItem(row)
      } catch (error) {
        this.$message.error('更新失败：' + error.message)
      } */
    },
    handleDateChange(row) {
      this.updateSchedule(row)
    },
    handleNotifyTypeChange(row, type) {
      const typeField = type === 'lawyer' ? 'islawyermsg' : 'isclientmsg'
      const daysField = `${type}NotifyDays`
      // 当选择不通知或当日时，将天数设为0
      if ([0, 1].includes(row[typeField])) {
        row[daysField] = 0
      } else if (row[daysField] === 0) {
        // 当选择提前或延后时，如果天数为0，默认设为1
        row[daysField] = 1
      }
      this.updateSchedule(row)
    },
    handleNotifyDaysChange(row, type) {
      this.updateSchedule(row)
    },
    handleLawyerChange(row) {
      this.updateSchedule(row)
    },
    handleScheduleChange(row) {
      // 将布尔值转换为0/1
      row.autoschedule = row.switchValue ? 1 : 0
      this.updateSchedule(row)
    },
    handleIsshowChange(row) {
      // 将布尔值转换为0/1
      row.isshow = row.isshowValue ? 1 : 0
      this.updateSchedule(row)
    },
    validateDays(row, type) {
      const days = row[`${type}NotifyDays`]
      if (days < 1) {
        row[`${type}NotifyDays`] = 1
      } else if (days > 30) {
        row[`${type}NotifyDays`] = 30
      }
      // 确保值为整数
      row[`${type}NotifyDays`] = Math.floor(row[`${type}NotifyDays`])
      this.updateSchedule(row)
    },
    handleLawyerMsgChange(row) {
      this.updateSchedule(row)
    },
    handleClientMsgChange(row) {
      this.updateSchedule(row)
    },
    async handleClientViewChange(value) {
      this.isclientview = value ? 1 : 0
      try {
        await this.updateClientView()
        this.$message({
          type: 'success',
          message: '更新成功'
        })
      } catch (error) {
        this.$message.error('更新失败：' + error.message)
        this.isClientViewEnabled = !value
      }
    },
    async updateClientView() {
      console.log('更新客户可见状态：', this.isclientview)
      const caseId = this.$route.query.id
      if (!caseId) {
        this.$message.error('案件ID不能为空')
        return
      }
      const res = await caseApi.updateClientView({caseid: caseId, isclientview: this.isclientview})
      console.log('更新客户可见状态成功', res)
      this.fetchData()

    },
    goBack() {
      this.$router.push({
        path: '/cases/info',
        query: {
          id: this.$route.query.id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.index-container {
  width: 100%;
  min-height: 100vh;
  background: #f0f2f5;
}

.schedule-panel {
  padding: 20px;
  margin-top: 60px;

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 10px;

    .header-left {
      display: flex;
      align-items: center;
      gap: 12px;

      .back-btn {
        font-size: 14px;
        padding: 0;
        color: #409EFF;

        &:hover {
          color: #66b1ff;
        }
      }

      h2 {
        color: #303133;
        margin: 0;
        font-weight: 600;
      }
    }

    .case-info {
      display: flex;
      align-items: center;
      gap: 20px;

      span {
        color: #606266;
        font-size: 14px;
      }

      .view-switch {
        display: flex;
        align-items: center;
        gap: 8px;

        .switch-label {
          color: #606266;
          font-size: 14px;
        }
      }
    }
  }

  .schedule-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  }
}

.notify-time, .notify-object, .sms-template {
  .notify-item, .template-item {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    .label {
      display: inline-block;
      width: 50px;
      color: #606266;
      text-align: right;
      margin-right: 8px;
      font-size: 13px;
    }

    .client-name {
      color: #606266;
      font-size: 13px;
    }

    .template-text {
      display: inline-block;
      max-width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #606266;
      font-size: 13px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.notify-time {
  .notify-row {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
    
    .notify-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      white-space: nowrap;

      .label {
        display: inline-block;
        width: 42px;
        color: #606266;
        text-align: right;
        margin-right: 8px;
        font-size: 13px;
      }

      .input-wrapper {
        display: flex;
        align-items: center;
        min-width: 180px;
      }

      .days-wrapper {
        display: flex;
        align-items: center;
        margin-left: 4px;
      }

      .days-input {
        width: 100px;
        .el-input__inner {
          padding: 0 4px;
          text-align: center;
        }
        // 隐藏输入框的上下箭头
        :deep(.el-input__inner::-webkit-outer-spin-button),
        :deep(.el-input__inner::-webkit-inner-spin-button) {
          -webkit-appearance: none;
          margin: 0;
        }
        :deep(.el-input__inner[type="number"]) {
          -moz-appearance: textfield;
        }
      }

      .days-label {
        color: #606266;
        font-size: 13px;
        margin-left: 2px;
      }
    }
  }
}

:deep(.el-select) {
  width: 80px;
}

:deep(.el-input-number) {
  .el-input__inner {
    padding: 0 4px;
    text-align: center;
  }
  .el-input-number__decrease, 
  .el-input-number__increase {
    width: 22px;
  }
}

:deep(.el-table) {
  .schedule-enabled-row {
    background-color: #f0f9eb;
  }

  td {
    padding: 6px 0;
  }

  .cell {
    padding: 0 8px;
  }
}

:deep(.custom-date-picker) {
  width: 130px !important;
  
  .el-input__inner {
    padding: 0 8px;
    height: 32px;
    line-height: 32px;
  }
  
  .el-input__prefix {
    left: 2px;
  }
  
  .el-input__suffix {
    right: 2px;
  }
}

:deep(.custom-select) {
  .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}

:deep(.el-tag) {
  font-weight: normal;
}

:deep(.el-tooltip__popper) {
  max-width: 300px;
  line-height: 1.5;
}

.notify-object {
  .notify-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.msg-input {
  width: 160px;
  :deep(.el-input__inner) {
    text-align: center;
  }
}

.client-msg-inputs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  .msg-input {
    width: 120px;
    :deep(.el-input__inner) {
      text-align: center;
    }
  }
}

</style>
